var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Calendar", {
        ref: "calendar",
        attrs: {
          attributes: _vm.attributes,
          "min-date": _vm.minDate,
          "max-date": _vm.maxDate
        },
        on: { dayclick: _vm.onDayClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }